import React, { useRef } from "react";
import Modal from "react-bootstrap/Modal";
import styles from "../../styles/shap_of_you.module.scss";
import { GalleryPermissionScreenProps } from "./types";

const GalleryPermissionScreen: React.FC<GalleryPermissionScreenProps> = ({
  show,
  onHide,
  onImageSelect,
  onPermissionDenied,
  logStep,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  // Handle "Allow this time" - one-time permission
  const handleAllowThisTime = () => {
    // Store permission in localStorage
    localStorage.setItem("galleryPermissionGranted", "true");

    // Log gallery permission granted (non-blocking)
    if (logStep) {
      logStep("gallery_permission_granted");
    }

    // Trigger file input
    fileInputRef.current?.click();

    // Close modal
    onHide();
  };

  // Handle "Allow on every visit" - persistent permission
  const handleAllowEveryVisit = () => {
    // Store permission in localStorage
    localStorage.setItem("galleryPermissionGranted", "true");

    // Log gallery permission granted (non-blocking)
    if (logStep) {
      logStep("gallery_permission_granted");
    }

    // Trigger file input
    fileInputRef.current?.click();

    // Close modal
    onHide();
  };

  // Handle "Don't Allow"
  const handleDontAllow = () => {
    // Log gallery permission denied (non-blocking)
    if (logStep) {
      logStep("gallery_permission_denied", {
        error_message: "User denied gallery permission",
      });
    }

    // Close modal
    onHide();

    // Navigate to permission denied page
    onPermissionDenied();
  };

  // Handle file selection
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && onImageSelect) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        onImageSelect(base64String);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        className={styles.custom_modal}
        centered
      >
        <Modal.Body>
          <div className={styles.modal}>
            <h3>
              sencogoldanddiamonds.com <br /> wants to
            </h3>

            <label className={styles.checkbox}>
              <svg
                width="20"
                height="16"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.5 12H22.5146"
                  stroke="#46474C"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M18.75 31.5H9C7.80653 31.5 6.66193 31.0259 5.81802 30.182C4.97411 29.3381 4.5 28.1935 4.5 27V9C4.5 7.80653 4.97411 6.66193 5.81802 5.81802C6.66193 4.97411 7.80653 4.5 9 4.5H27C28.1935 4.5 29.3381 4.97411 30.182 5.81802C31.0259 6.66193 31.5 7.80653 31.5 9V18.75"
                  stroke="#46474C"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M4.5 24L12 16.5C13.392 15.1605 15.108 15.1605 16.5 16.5L21.75 21.75"
                  stroke="#46474C"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M21 21L22.5 19.5C23.5185 18.5205 24.7095 18.2565 25.821 18.711"
                  stroke="#46474C"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M28.5 33V24"
                  stroke="#46474C"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M33 28.5L28.5 24L24 28.5"
                  stroke="#46474C"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>Access your photos</span>
            </label>

            <div className={styles.actions}>
              <button className={styles.primary} onClick={handleAllowThisTime}>
                Allow this time
              </button>
              <button className={styles.primary} onClick={handleAllowEveryVisit}>
                Allow on every visit
              </button>
              <button className={styles.primary} onClick={handleDontAllow}>
                Don&apos;t Allow
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Hidden file input */}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </>
  );
};

export default GalleryPermissionScreen;
